module.exports = __webpack_public_path__ + "img/bullet.12d2e72e.svg";